import DropDownCart from './DropDownCart'

export default {
    'dropdown-cart': DropDownCart
}
